// extracted by mini-css-extract-plugin
export var banner = "personal-training-page-module--banner--fT02e";
export var content = "personal-training-page-module--content--6ZP76";
export var trainingSwitcher = "personal-training-page-module--training-switcher--BDZnv";
export var wrapper = "personal-training-page-module--wrapper--vC052";